// extracted by mini-css-extract-plugin
export default {"slideContainer":"+dUYy","slide":"bu95c"};